import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

export const getAllThemes = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllThemesSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllThemesFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addTheme = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addThemeSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addThemeFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getTheme = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getThemeSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getThemeFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editTheme = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editThemeSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editThemeFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteTheme = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteThemeSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteThemeFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
